export default __webpack_public_path__ + "static/media/gilroy-regular-webfont.9ee8f76d.woff2";